import { render, staticRenderFns } from "./CreateFulfillment.vue?vue&type=template&id=4d293509"
import script from "./CreateFulfillment.vue?vue&type=script&lang=js"
export * from "./CreateFulfillment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports